import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Chosen } from '../chosen/Chosen'
import classnames from 'classnames'

import './Pager.scss'

export const Pager = ({
  className,
  currentPage,
  hideItemPerPage,
  itemPerPage,
  itemsLabel,
  ofLabel,
  onChange,
  totalItems,
  'data-mu-test': dataAttributeTest
}) => {
  const compClassName = classnames('row pager-component', className)

  let btnLeftClass = 'pager-component_btn pager-component_btn-left'
  let btnRightClass = 'pager-component_btn pager-component_btn-right'
  const [loaderPrev, setLoaderPrev] = useState(false)
  const [loaderNext, setLoaderNext] = useState(false)
  // const [disablePrev, setDisablePrev] = useState(false)
  // const [disableNext, setDisableNext] = useState(false)
  const [disableComponent, setDisableComponent] = useState(false)
  let startValue
  let endValue
  let disableNext = false
  let disablePrev = false

  const propsItemPerPage = () => ({
    isDisabled: false,
    isSearchable: false,
    onChange: '',
    value: itemPerPage
    // className: 'pager-component_counter'
  })
  let optionsItemPerPage = [
    { value: 5, label: '5 ' + itemsLabel },
    { value: 10, label: '10 ' + itemsLabel },
    { value: 25, label: '25 ' + itemsLabel },
    { value: 50, label: '50 ' + itemsLabel }
  ]
  const [value, setItemPerPage] = useState(false)

  useEffect(() => {
    setItemPerPage(itemPerPage)
    setLoaderPrev(false)
    setLoaderNext(false)
    setDisableComponent(false)
    // setPagerValue()
  }, [itemPerPage, currentPage])

  setPagerValue()

  function setPagerValue () {
    startValue = (currentPage - 1) * itemPerPage + 1
    endValue = (currentPage - 1) * itemPerPage + itemPerPage
    if (endValue > totalItems) { endValue = totalItems }

    setBtnClass()
  }

  function setBtnClass () {
    if (currentPage === 1) {
      btnLeftClass += ' active is-disabled'
      // setDisablePrev(true)
      disablePrev = true
    } else {
      btnLeftClass += ' active'
      // setDisablePrev(false)
    }

    let lastPage = Math.ceil(totalItems / itemPerPage)
    if (currentPage >= lastPage) {
      btnRightClass += ' active is-disabled'
      disableNext = true
      // setDisableNext(true)
    } else {
      btnRightClass += ' active'
      // setDisableNext(false)
    }
  }

  const onChangeItemPerPage = (e) => {
    if (!disableComponent) {
      setItemPerPage(e.value)
      itemPerPage = e.value
      setDisableComponent(true)
      onChange({
        currentPage: 1,
        itemsPerPage: e.value,
        action: 'view'
      })
    }
  }

  const goPrevPage = () => {
    if (!disableComponent && !disablePrev) {
      setLoaderPrev(true)
      setDisableComponent(true)

      onChange({ currentPage: currentPage - 1, itemsPerPage: itemPerPage, action: 'prev' })
    }
  }

  const goNextPage = () => {
    if (!disableComponent && !disableNext) {
      setLoaderNext(true)
      setDisableComponent(true)
      onChange({ currentPage: currentPage + 1, itemsPerPage: itemPerPage, action: 'next' })
    }
  }

  const stylesItemPerPage = {

    option: () => {
      return {
        color: 'red',
        padding: '0'

      }
    }

  }

  function btnPrevClassName () {
    if (!loaderPrev) {
      if (!disableComponent) { return btnLeftClass } else { return btnLeftClass + ' is-disabled' }
    } else { return btnLeftClass.replace('active', 'is-loading') }
  }

  function btnNextClassName () {
    if (!loaderNext) {
      if (!disableComponent) { return btnRightClass } else { return btnRightClass + ' is-disabled' }
    } else { return btnRightClass.replace('active', 'is-loading') }
  }

  return (
    <div className={compClassName}>

      {!hideItemPerPage && (optionsItemPerPage[0].value < totalItems) && (
        <div className='container-select pager-component_view '>
          <Chosen
            {...propsItemPerPage()}
            options={optionsItemPerPage}
            styles={stylesItemPerPage}
            isDisabled={disableComponent}
            value={value}
            onChange={e => onChangeItemPerPage(e)}
            data-mu-test={classnames(
              'select--items-per-page',
              dataAttributeTest && [
                `${dataAttributeTest}__select--items-per-page`
              ]
            )}
          />
        </div>
      )}

      {optionsItemPerPage[0].value < totalItems && (
        <div className='pager-component_pages'>
          <div
            onClick={() => goPrevPage()}
            className={btnPrevClassName()}
            data-mu-test={classnames(
              'button--prev-page',
              dataAttributeTest && [`${dataAttributeTest}__button--prev-page`]
            )}
          />
          <div className='pager-component_counter'>
            <span >{startValue} - {endValue} {ofLabel} {totalItems}</span>
          </div>
          <div
            onClick={() => goNextPage()}
            className={btnNextClassName()}
            data-mu-test={classnames(
              'button--next-page',
              dataAttributeTest && [`${dataAttributeTest}__button--next-page`]
            )}
          />
        </div>
      )}

      {currentPage !== 0 && optionsItemPerPage[0].value >= totalItems && (
        <span className='pager-component_counter-only-text'>{startValue} - {endValue} {ofLabel} {totalItems}</span>
      )}
    </div>
  )
}

Pager.defaultProps = {
  hideItemPerPage: false,
  ofLabel: 'of',
  itemsLabel: 'items'
}

Pager.propTypes = {
  className: PropTypes.string,
  currentPage: PropTypes.number,
  hideItemPerPage: PropTypes.bool,
  itemPerPage: PropTypes.number,
  itemsLabel: PropTypes.string,
  ofLabel: PropTypes.string,
  onChange: PropTypes.func,
  totalItems: PropTypes.number,
  /**
   * Additional values for data-attribute used for tests and tracking. The value is passed to
   * prev/next page buttons and 'items per page' select
   **/
  'data-mu-test': PropTypes.string
}
